import { z } from 'zod';

import { ContentfulSysSchema } from './contentful-sys.validator';
import { CountryLanguagePairEntrySchema } from './country-language-pair.validator';

export const CountryLanguageTableEntrySchema = z.object({
  sys: ContentfulSysSchema,
  fields: z.looseObject({
    internalName: z.string(),
    countryLanguagePairs: z.array(CountryLanguagePairEntrySchema)
  }),
  metadata: z
    .object({
      tags: z.array(z.any()).optional().nullable()
    })
    .optional()
    .nullable()
});
